export default __webpack_public_path__ + "static/media/bday1.7cbdf6bf.jpg";